export default "__VITE_ASSET__7e784d45__"